export default __webpack_public_path__ + "static/media/bg-set-availability.6260fe71.png";